import { Dexterity, IDataGridRow, baseballLogicService, constants } from '@trackman/baseball-shared-components';
import { DataKey } from 'enums/DataKey';
import { IReviewDataRow } from 'interfaces/review/IReviewDataRow';
import { IReviewInning } from 'interfaces/review/IReviewInning';
import _ from 'lodash';
import { ReviewDataRowProps } from './ReviewDataRowProps';

export class ReviewDataRow extends ReviewDataRowProps implements IReviewDataRow, IDataGridRow {
  getValue(dataKey: string) {
    return this[dataKey as keyof ReviewDataRowProps];
  }

  isVisible() {
    return !this.isDeleted && this.displayIndex > -1;
  }

  clone(): ReviewDataRow {
    return _.cloneDeep(this);
  }

  isHidden() {
    return this.displayIndex === -1;
  }

  update(dataKey: string, newValue: any): void {
    const oldValue = this[dataKey as keyof ReviewDataRowProps];
    if (JSON.stringify(oldValue) === JSON.stringify(newValue)) {
      return;
    }

    (this as unknown as Record<string, any>)[dataKey] = newValue;

    this.isChanged = true;
    if (dataKey === DataKey.Inning && (oldValue as IReviewInning).isTopInning !== (newValue as IReviewInning).isTopInning) {
      this.pitcher = {
        teamName: baseballLogicService.isHomeTeamBatting((newValue as IReviewInning).isTopInning) ? this.awayTeamName : this.homeTeamName,
        id: constants.emptyGuid,
        isHomeTeam: (newValue as IReviewInning).isTopInning,
        position: '',
        name: '',
        foreignIds: [],
        isPlaceholder: true,
        birthDate: null,
        ids: null,
        jerseyNumber: '',
        nameRef: '',
      };
      this.batter = {
        teamName: baseballLogicService.isHomeTeamBatting((newValue as IReviewInning).isTopInning) ? this.homeTeamName : this.awayTeamName,
        id: constants.emptyGuid,
        isHomeTeam: !(newValue as IReviewInning).isTopInning,
        position: '',
        name: '',
        foreignIds: [],
        isPlaceholder: true,
        birthDate: null,
        ids: null,
        jerseyNumber: '',
        nameRef: '',
      };
      this.catcher = {
        teamName: baseballLogicService.isHomeTeamBatting((newValue as IReviewInning).isTopInning) ? this.awayTeamName : this.homeTeamName,
        id: constants.emptyGuid,
        isHomeTeam: (newValue as IReviewInning).isTopInning,
        position: '',
        name: '',
        foreignIds: [],
        pitchingHandedness: Dexterity.Undefined,
        isPlaceholder: true,
        birthDate: null,
        ids: null,
        jerseyNumber: '',
        nameRef: '',
      };
    }
  }
}
